import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const EpLoadingPage = ({ isVisible }) => {
  useEffect(() => {
    const appBody = document.getElementById('app__container');

    if (isVisible) {
      appBody.style.overflow = 'hidden';
      appBody.style.height = '100vh';
      appBody.style.width = '100vw';
    } else {
      appBody.removeAttribute('style');
    }
  }, [isVisible]);

  return (
    <div className={`loading loading--page ${isVisible ? '' : 'loading__hidden'}`}>
      <div className="loading__spinner spinner-border" role="status">
        <span className="visually-hidden" />
      </div>
      <div className="loading__backdrop" />
      <div className="loading__background-circle" />
    </div>
  );
};

export default EpLoadingPage;

EpLoadingPage.defaultProps = {
  isVisible: false,
};

EpLoadingPage.propTypes = {
  isVisible: PropTypes.bool,
};
